const JSConstants = require('_core_ext/constants');
const form = document.querySelector(JSConstants.ID_CREATE_RETURN_FORM);
const imgPaths = document.querySelectorAll(JSConstants.CLASS_IMAGE_PATH);


function uploud(selectedImages) {

    const formData = new FormData(form);
    selectedImages.forEach(file => {
        formData.append(file.image.name, file.image, file.image.name);
    });

    $.ajax({
        type: 'GET',
        url: Urls.getCsrfToken,
        context: document.body,
        dataType: 'json',
        success: function(csrfjson) {
            var csrf_name = csrfjson.name;
            var csrf_value = csrfjson.value;
            formData.append(csrf_name, csrf_value);
            uploudImage(formData);
        },
        error: function(error) {
            console.log('error' + error);
        }
    });

    function uploudImage(formData) {
        $.ajax({
            type: 'POST',
            url: Urls.uploadImages,
            data: formData,
            processData: false,
            contentType: false
        }).done(function(response) {
            const uloudedImagesPath = response.imgsFullPath;

            imgPaths.forEach((imgPath, i) => {
                imgPath.value = uloudedImagesPath[i] || '';
            });
            document.querySelector(JSConstants.CLASS_SEND_BTN).click();
        });
    }
}



exports.init = function (selectedImages) {
    uploud(selectedImages);
};
